
















































































import Vue from "vue";
import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { Shipnity } from "../models/Shipnity";

export default Vue.extend({
  mixins: [pagination, dialog, permission],
  data() {
    const shops: Shipnity[] = [];

    return {
      shops
    };
  },
  computed: {
    hasCreateShipnityPermission() {
      return (this as any).hasPermission(PermissionName.SHIPNITY_CREATE);
    }
  },
  watch: {
    async "$route.query"() {
      await this.getShopsShipnity();
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    await Promise.all([this.getShopsShipnity()]);
  },
  methods: {
    async getShopsShipnity() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      try {
        const {
          data,
          meta
        } = await (this as any).$dep.shipnityUseCase.getShipnity(form);

        this.shops = data;

        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    },
    goToShipnityCreatePage() {
      this.$router.push({ name: "ShipnityCreatePage" });
    },
    goToShipnityUpdatePage(id: any) {
      this.$router.push({ name: "ShipnityUpdatePage", params: { id } });
    },
    async syncProductDialog(shipnity: Shipnity) {
      const isComfirmed = await (this as any).alertConfirm(
        "Sync สินค้า",
        `คุณต้องการที่จะ Sync สินค้าร้าน ${shipnity.shopName} ใช่ไหม?`
      );

      if (isComfirmed) {
        this.syncProduct(shipnity.shopId!);
      }
    },
    async syncProduct(id: number) {
      try {
        await (this as any).$dep.shipnityUseCase.syncProductByShopId(id);
        (this as any).alertSuccess("Success", "เริ่มการ Sync สินค้าแล้ว");
        this.getShopsShipnity();
      } catch (error) {
        console.log(error);
      }
    },
    async syncStockDialog(shipnity: Shipnity) {
      const isComfirmed = await (this as any).alertConfirm(
        "Sync Stock",
        `คุณต้องการที่จะ Sync Stock ร้าน ${shipnity.shopName} ใช่ไหม?`
      );

      if (isComfirmed) {
        this.syncStock(shipnity.shopId!);
      }
    },
    async syncStock(id: number) {
      try {
        await (this as any).$dep.shipnityUseCase.syncStockByShopId(id);
        (this as any).alertSuccess("Success", "เริ่มการ Sync Stock แล้ว");
        this.getShopsShipnity();
      } catch (error) {
        console.log(error);
      }
    },
    async deleteShopDialog(shipnity: Shipnity) {
      const isComfirmed = await (this as any).alertConfirm(
        "ลบร้าน",
        `คุณต้องการที่จะลบร้าน ${shipnity.shopName} ใช่ไหม?`
      );

      if (isComfirmed) {
        this.deleteShop(shipnity.id!);
      }
    },
    async deleteShop(id: number) {
      try {
        await (this as any).$dep.shipnityUseCase.deleteShipnity(id);
        (this as any).alertSuccess("Success", "ลบร้านสำเร็จ");
        this.getShopsShipnity();
      } catch (error) {
        console.log(error);
      }
    }
  }
});
